"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceGroupType = void 0;
/**
 * This enum maps the PriceGroup type to a PriceGroup used in SAP
 */
var PriceGroupType;
(function (PriceGroupType) {
    PriceGroupType["SupplyCost"] = "VER";
    PriceGroupType["GridCost"] = "NET";
    PriceGroupType["VatAndSurplus"] = "TAX";
    PriceGroupType["ReturnSupply"] = "RET";
    PriceGroupType["Discount"] = "DIS";
})(PriceGroupType = exports.PriceGroupType || (exports.PriceGroupType = {}));
